import { apiClient } from '@/http/apiClient';
import AdminExport from "@/models/AdminExport";
import { AxiosPromise } from 'axios';

const ROOT_PATH = 'adminExport';
class AdminExportService {

     public getAll(): AxiosPromise<any> {
        return apiClient.get(ROOT_PATH);
     }

     public save(adminExports: AdminExport[]): Promise<any> {
         return apiClient.post(ROOT_PATH, adminExports);
     }
     public delete(id: string): AxiosPromise<any> {
         return apiClient.delete(`${ROOT_PATH}/${id}`);
     }
 
}

export default new AdminExportService();